import { RouteObject } from "react-router-dom";
import { withHandle } from "../../utils/route.util";
import { path as createPath } from "./CustomerProductCreateView";
import { CustomerProductFilterInner, path as filterPath } from "./CustomerProductFilter";
import { CustomerProductView, ProductInfoV2 } from "./CustomerProductView";
import { ProductCreateNavigator } from "./ProductCreateNavigator";
import { CustomerProductEditView } from "./CustomerProductEditView";
import { featureFlags } from "../../featureFlags";

export const productCreateRoute: RouteObject = {
  path: createPath,
  element: <ProductCreateNavigator />,
  ...withHandle("customer-product-create"),
};

export const productDetailsRoute: RouteObject = featureFlags.newTableView
  ? {
      path: ":id",
      element: <ProductInfoV2 />,
      ...withHandle("customer-product-detail"),
    }
  : {
      path: ":id",
      element: <CustomerProductView />,
      ...withHandle("customer-product-detail"),
    };

export const productFiltersRoute: RouteObject | undefined = featureFlags.newTableView
  ? {
      path: filterPath,
      element: <CustomerProductFilterInner />,
    }
  : undefined;

export const productEditRoute: RouteObject | undefined = featureFlags.newTableView
  ? undefined
  : {
      path: ":id/edit",
      element: <CustomerProductEditView />,
      ...withHandle("customer-product-edit"),
    };
